export default __webpack_public_path__ + "8fb0d338e17a3ed76d8511ba35f9e366.ttf";